module.exports = __webpack_public_path__ + "static/media/icon-out-of-pocket.0bb30fc5.svg";